import { StyledSpinner } from './styled';

const Spinner = () => {
  return <StyledSpinner className='loader'>Loading...</StyledSpinner>;
};

export default Spinner;
